import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import withRouter from '../../services/util/withRouter';
import { connect } from 'react-redux';
import firestore from '../../services/api/firestore';
import {
	collection,
	query,
	QuerySnapshot,
	onSnapshot,
	where,
	orderBy
} from 'firebase/firestore';
import classes from './NotificationsDropdown.module.css';
// import socketIo from 'socket.io-client';

import {
	Badge,
	NavLink,
	NavItem,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Dropdown
} from 'reactstrap';
import walletApi from '../../services/api/wallet';

class MassageDropdown extends Component {
	state = {
		numberOfUnreadNotifications: 0,
		messages: [],
		dropdownOpen: false
	};
	subscriptions = [];

	componentDidMount() {
		if (this.props.user && this.props.user.cmID) {
			walletApi
				.getPartnerWallet(this.props.user.cmID)
				.then(partnerWalletResponse => {
					if (
						partnerWalletResponse &&
						partnerWalletResponse.data &&
						partnerWalletResponse.data.wallets &&
						partnerWalletResponse.data.wallets.length > 0
					) {
						firestore.get().then(db => {
							const q = query(
								collection(db, 'messages'),
								where(
									'recipentIdentifier',
									'==',
									partnerWalletResponse.data.wallets[0].id
								),
								where('readDate', '==', null)
							);
							this.subscriptions.push(
								onSnapshot(q, data => this.onMessagesChange(data))
							);
						});
					}
				});
		}
	}

	componentWillUnmount() {
		this.subscriptions.forEach(unSub => unSub());
	}

	onMessagesChange(data) {
		const loadedData = data.docs.map(doc => doc.data());

		const uniqueSenders = loadedData.filter(
			(item, i, ar) =>
				ar.findIndex(
					subItem => subItem.senderIdentifier == item.senderIdentifier
				) === i
		);

		this.setState({
			numberOfUnreadNotifications: uniqueSenders ? uniqueSenders.length : 0,
			messages: uniqueSenders ? uniqueSenders : []
		});
	}

	// componentDidMount() {
	// 	this.initWebsocket();

	// 	notificationsAPI.getUnreadNotifications().then(result => {
	// 		this.setState({ numberOfUnreadNotifications: result.data });
	// 	});

	// 	// Check for service worker
	// 	if ('serviceWorker' in navigator) {
	// 		this.registerPushNotificationSubscription().catch(err =>
	// 			console.error(err)
	// 		);
	// 	}
	// }

	// initWebsocket() {
	// 	if (this.props.usePrivilege && this.props.usePrivilege.privatekey) {
	// 		const socket = socketIo(process.env.REACT_APP_BACKEND_WEBSOCKET_SERVER, {
	// 			transport: ['websocket']
	// 		});
	// 		socket.on('connect', () => {
	// 			socket.emit('join', this.props.usePrivilege.privatekey);
	// 		});
	// 		socket.on('refreshnotifications', () => {
	// 			notificationsAPI.getUnreadNotifications().then(result => {
	// 				this.setState({ numberOfUnreadNotifications: result.data });
	// 			});
	// 		});
	// 	}
	// }

	toggle = () => {
		if (!this.state.dropdownOpen) {
			// notificationsAPI.getNotifications(0, 5).then(notifications => {
			// 	this.setState({ notifications: notifications.data });
			// });
		}
		this.setState({
			numberOfUnreadNotifications: 0,
			dropdownOpen: !this.state.dropdownOpen
		});
	};

	renderBadge() {
		if (this.state.numberOfUnreadNotifications > 0) {
			if (this.state.numberOfUnreadNotifications > 99) {
				return (
					<Badge pill color="info" className="ml-1">
						99+
					</Badge>
				);
			} else {
				return (
					<Badge pill color="info" className="ml-1">
						{this.state.numberOfUnreadNotifications}
					</Badge>
				);
			}
		} else {
			return null;
		}
	}

	async onMessageClick(message) {
		if (message.senderIdentifier && message.senderIdentifier.indexOf('@') > 0) {
			this.props.history.push(
				`/invisible_touch_manager?userEmail=${message.senderIdentifier}`
			);
		}
	}

	getMessageShortenedText(text) {
		const maxLength = 30;
		let result = '';
		if (text) {
			if (text.length > maxLength) {
				result = text.slice(0, 30) + '...';
			} else {
				result = text;
			}
		}
		return result;
	}

	renderDropdownItems() {
		if (this.state.messages) {
			return this.state.messages.map((message, index) => {
				const textDate = message.sendDate
					? new Date(message.sendDate).toLocaleString()
					: '';

				return (
					<DropdownItem
						key={index}
						onClick={() => this.onMessageClick(message)}
					>
						<div className={classes.IconDiv}>
							<i
								className="fa fa-comment"
								style={{ fontSize: '1.5rem' }}
								aria-hidden="true"
							></i>
						</div>
						<div className={classes.TextDiv}>
							<p>{this.getMessageShortenedText(message.text)}</p>
							<p className={classes.DateParagraph}>{textDate}</p>
						</div>
					</DropdownItem>
				);
			});
		} else {
			return null;
		}
	}

	render() {
		return (
			<Dropdown
				isOpen={this.state.dropdownOpen}
				className={this.props.className}
				toggle={this.toggle}
			>
				<DropdownToggle nav className="text-uppercase" caret>
					<i className="icon-envelope"></i>
					{this.renderBadge()}
				</DropdownToggle>
				<DropdownMenu right width="200">
					<DropdownItem header tag="div" className="text-center">
						<strong>
							{this.props.t('invisibleTouchManager.messagePanel.messages')}
						</strong>
					</DropdownItem>
					{this.renderDropdownItems()}
					<DropdownItem footer="true" tag="div" className="text-center">
						<NavLink
							href="#/invisible_touch_manager?unreadMessages=true"
							className="nav-link"
						>
							<strong>
								{this.props.t('invisibleTouchManager.messagePanel.showAll')}
							</strong>
						</NavLink>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user
});

export default withRouter(
	connect(mapStateToProps)(withTranslation()(MassageDropdown))
);
